// extracted by mini-css-extract-plugin
export default {"content":"Tab_content__M3BJX"};